<template>
  <div class="warpper">
    <div class="modal">
      <div class="flex modal_flex">
        <div class="modal-l">
          <div class="modal-name">
            <span>红寺堡区<br />养殖产业数字化服务平台</span>
          </div>
          <div class="modal-img">
            <img src="../assets/images/t1.png" alt="" />
          </div>
        </div>
        <div class="modal-r">
          <div class="modal-lo">
            <img src="../assets/images/login-he.png" alt="" />
          </div>
          <form>
            <div class="form-group flex-center">
              <div class="form-icon">
                <img src="../assets/images/icon6.png" alt="" />
              </div>
              <div class="form-input">
                <input
                  type="text"
                  placeholder="请输入用户名"
                  v-model="loginForm.account"
                />
              </div>
            </div>
            <div class="form-group flex-center">
              <div class="form-icon">
                <img src="../assets/images/icon7.png" alt="" />
              </div>
              <div class="form-input">
                <input
                  type="password"
                  placeholder="请输入密码"
                  v-model="loginForm.password"
                />
              </div>
            </div>
            <div class="form-group flex">
              <div
                class="form-icon validate"
                style="width: 22px; height: 100%; padding-top: 6px"
              >
                <img src="../assets/images/validate.png" alt="" />
              </div>
              <div class="" style="background-color: white">
                <input
                  style="height: 100%"
                  placeholder="请输入验证码"
                  v-model="loginForm.code"
                />
              </div>
              <div
                @click="getCodeUrl"
                style="display: inline-block; width: 30%"
              >
                <img
                  style="width: 100%; height: 100%"
                  :src="codeUrl"
                  alt="点击刷新"
                />
              </div>
            </div>
            <!-- <div class="form_f flex-center">
                            <div class="form-group flex-center">
                                <div class="form-icon"><img src="../assets/images/icon8.png" alt=""></div>
                                <div class="form-input"><input type="text" placeholder="请输入验证码"></div>
                            </div>
                            <div class="form-img"><img src="../assets/images/yzm.jpg" alt=""></div>
                        </div> -->
            <el-button class="btn" @click="handleLogin()">登录</el-button>
            <div class="form-ft flex-center flex_zBetween">
              <router-link to="">找回密码</router-link>
              <router-link to="">立即注册</router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Foot from "@/components/Foot.vue";
import { mapMutations } from "vuex";
export default {
  name: "login",
  components: {
    Foot,
  },
  data() {
    return {
      loginForm: {
        account: "",
        password: "",
        code: "",
        uuid: "",
      },
      code: "",
      codeUrl: "",
    };
  },
  async mounted() {
    this.getCodeUrl();
  },
  methods: {
    ...mapMutations(["changeLogin"]),
    handleLogin() {
      let _this = this;
      if (this.loginForm.account === "" || this.loginForm.password === "") {
        this.$message({
          message: "账号或密码不能为空",
          type: "warning",
        });
      } else {
        console.log("else");
        let params = Object.assign({}, _this.loginForm);
        console.log("params", params);
        this.$api.login
          .postLogin(params)
          .then((res) => {
            const { result } = res;
            _this.changeLogin({
              Authorization: result.token,
            });
            _this.$router.push("/Screen");
            localStorage.setItem("account", this.loginForm.account);
            localStorage.setItem("password", this.loginForm.password);
            this.$message({
              message: "登陆成功！",
              type: "success",
            });
          })
          .catch((error) => {
            console.log("error", error);
            _this.getCodeUrl();
          });
      }
    },
    getCodeUrl() {
      let _this = this;
      this.$api.login.loginCode().then((res) => {
        _this.loginForm.uuid = res.result.uuid;
        _this.codeUrl = res.result.codeBase64;
      });
    },
  },
};
</script>
<style scoped>
.warpper {
  background-image: url(../../src/assets/images/bj.jpg);
  min-height: 100vh;
}

.modal {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.56);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}

.modal:before {
  content: "";
  width: 100%;
  height: 742px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-image: url(../assets/images/login-bj.png);
  background-position: center;
  background-size: cover;
}

.modal_flex {
  width: 1000px;
  position: relative;
}

.modal-l {
  width: 628px;
  border: 1px solid #1aa2b0;
  background-color: rgba(0, 56, 215, 0.2);
  border-radius: 10px 0 0 10px;
  position: relative;
  height: 470px;
  z-index: 2;
  padding: 46px;
}

.modal-l::before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: #01127b;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 10px 0 0 10px;
  z-index: -1;
  box-shadow: inset 0 0 46px 0 rgba(0, 255, 246, 0.2);
}

.modal-name {
  font-size: 47px;
  font-weight: bold;
  position: relative;
  z-index: 22;
}

.modal-name span {
  background-image: -webkit-linear-gradient(bottom, #b9e4ff, #ffffff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.modal-img {
  position: absolute;
  bottom: 0;
  right: 0;
}

.modal-img img {
  width: 100%;
  height: 455px;
}

.modal-r {
  background-color: rgba(2, 45, 166, 0.76);
  border: 1px solid #1aa2b0;
  border-radius: 0 10px 10px 0;
  flex: 1;
  margin-left: -1px;
  padding: 0 40px;
}

.modal-lo {
  width: 284px;
  height: 34px;
  margin: 50px auto 30px;
}

.modal-lo img {
  width: 100%;
  height: 100%;
}

.form-group {
  border: 1px solid #1aa2b0;
  background-color: rgba(0, 155, 255, 0.4);
  border-radius: 5px;
  padding: 0 10px;
  margin-bottom: 30px;
}

.form-icon {
  width: 18px;
  height: 22px;
  margin-right: 8px;
}

.form-icon img {
  width: 100%;
  height: 100%;
}

.form-input {
  flex: 1;
  flex-wrap: nowrap;
}

.form-input input {
  width: 100%;
  border: 0;
  outline: none;
  background-color: transparent;
  font-size: 14px;
  height: 40px;
  color: #ffffff;
}

.form-input input::-webkit-input-placeholder {
  font-size: 14px;
  color: #ffffff;
}

.form-img {
  width: 90px;
  height: 38px;
  margin-left: 12px;
}

.form-img img {
  width: 100%;
  height: 100%;
}

.form_f .form-group {
  margin-bottom: 0;
}

.modal-r .btn {
  width: 100%;
  height: 40px;
  background: linear-gradient(to bottom, #007dee, #02dff7);
  color: #ffffff;
  border: 0;
  border-radius: 5px;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 6px;
  cursor: pointer;
  margin: 30px 0;
}

.form-ft a {
  font-size: 14px;
  color: #ffffff;
}

.banner {
  background-image: url(../assets/images/banner-k.png);
  width: 720px;
  height: 486px;
  padding: 4px 3px 5px 7px;
  border-radius: 14px;
  position: relative;
  margin: 50px 0 0 120px;
}

.swiper img,
.banner_col {
  width: 100%;
  height: 100%;
  position: relative;
}

.banner_col,
.swiper {
  border-radius: 14px;
  overflow: hidden;
}

.banner_col p {
  background-color: rgba(0, 0, 0, 0.56);
  font-size: 20px;
  color: #ffffff;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 17px 20px;
}

.banner .swiper-pagination {
  bottom: 20px;
  right: 10px;
}

.banner /deep/ .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: #ffffff;
  opacity: 0.56;
  margin: 0 4px;
}

.banner /deep/ .swiper-pagination-bullet-active {
  background-color: #2bfaff;
  opacity: 1;
}
</style>
